export enum CardWidgetStyle {
    style1,
    style2,
    style3,
    style4,
    style5,
    style6,
    style7
}